<template>
  <AtomsSecondaryButton v-if="props.variant === 'outline'" font-mode="en" :on-click="props.onClick">{{ props.label }}</AtomsSecondaryButton>
  <AtomsPrimaryTextButton v-else :on-click="props.onClick">{{ props.label }}<span class="ml-1 inline-block text-gray4">&rsaquo;</span></AtomsPrimaryTextButton>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    label: string;
    onClick: () => void;
    variant?: 'text' | 'outline';
  }>(),
  { variant: 'text' },
);
</script>
